module.exports = __webpack_public_path__ + "static/media/team_05.4273c63e.png";